const $ = jQuery

export default function WoocommerceScroll () {
  $.scroll_to_notices = function (scrollElement) {
    if (scrollElement.length) {
      $('html, body').animate({ scrollTop: (scrollElement.offset().top - 90) }, 1000)
    }
  }
}
